import React from 'react';
import { Typography, Button, theme } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { useToken } = theme;

const MedicalRecords = () => {
  const { token } = useToken();

  return (
    <div style={{ textAlign: 'center', padding: '40px 0' }}>
      <FileTextOutlined style={{ 
        fontSize: '64px', 
        color: token.colorPrimary, 
        marginBottom: '16px' 
      }} />
      <Title level={4} style={{ color: token.colorTextHeading }}>
        Medical Records Module
      </Title>
      <Text type="secondary" style={{ 
        maxWidth: '500px', 
        margin: '0 auto',
        fontSize: '15px'
      }}>
        Access and manage patient medical history, test results, and treatment plans.
      </Text>
      <Button 
        type="primary" 
        size="large" 
        style={{ 
          marginTop: '24px',
          borderRadius: '12px',
          fontWeight: 500
        }}
      >
        Access Records
      </Button>
    </div>
  );
};

export default MedicalRecords;